import { Box, Dialog, Divider, IconButton, ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material"
import { PriaIconButton } from "./components/PriaIconButton"
import PriaSvgIcon from './assets/pria-icon.svg'
import { useTranslation } from "react-i18next"
import { List } from "antd"
import { Fragment, useState } from "react"
import { ArrowForward, Close } from "@mui/icons-material"
import { useHistory } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { initialTourAtom } from "../../atoms"

export const PriaChatTour = () => {
  const { t } = useTranslation()
  const [isChatOpen, setIsChatOpen] = useState(false)
  const history = useHistory()
  const setInitialTour = useSetRecoilState(initialTourAtom)

  const handleOption = (action) => {
    setIsChatOpen(false)
    action()
  }

  const options = [
    {
      label: t('chat.option.remake.tour'),
      action: () => setInitialTour(true)
    },
    {
      label: t('chat.option.new-scan.tour'),
      action: () => history.push('/scans/manage-scans')
    },
    {
      label: t('chat.option.search.tour'),
      action: () => history.push('/scans/search')
    },
    {
      label: t('chat.option.new-detector-class.tour'),
      action: () => history.push('/detectors/classes/new')
    },
    {
      label: t('chat.option.new-credential.tour'),
      action: () => history.push('/settingsMain/credentials/new')
    },
    {
      label: t('chat.option.engines.tour'),
      action: () => history.push('/detectors/engines')
    },
  ]

  return <>
    <PriaIconButton onClick={() => setIsChatOpen(true)} />

    <Dialog hideBackdrop open={isChatOpen} sx={{
      '& .MuiDialog-paper': {
        borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        width: 378,
        position: 'fixed', bottom: 60, right: 0
      }
    }}>
      <Stack direction='row' justifyContent='center' alignItems='center' sx={{ py: 3, px: 4 }} width={1}>
        <Stack direction='row' gap={2} width={1} >
          <img src={PriaSvgIcon} id='dsar-pria' style={{ width: 50, height: 50 }} />
          <Stack direction='column'>
            <Typography fontSize={20} fontWeight={700}>{t('PrIA · Assistente')}</Typography>
            <Stack direction='row' alignItems='center' width={1}>
              <div style={{
                width: 5,
                height: 5,
                borderRadius: '50%',
                backgroundColor: '#379160',
                marginBottom: 3,
                marginRight: 3
              }} />
              <Typography fontSize={12} fontWeight={400}>{t('Online · Data Discovery')}</Typography>
            </Stack>
          </Stack>
        </Stack>
        <IconButton sx={{ mb: 3, color: '#000' }} onClick={() => setIsChatOpen(false)}>
          <Close fontSize="medium" />
        </IconButton>
      </Stack>

      <Divider sx={{ width: 1, mb: 3, mt: -1 }} />

      <Stack mb={4} direction='row' spacing={0.5}>
        <img src={PriaSvgIcon} id='dsar-pria' style={{ width: 22, height: 22 }} />
        <Box sx={{ borderRadius: '0 16px 16px 16px', background: '#F5F5F5', padding: '8px 16px', width: 300 }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', fontSize: 14, marginBottom: '0.5rem' }}>
            {t('O que deseja explorar?')}
          </Typography>
          <List disablePadding>
            {options.map((option, index) => (
              <Fragment key={option.label}>
                <ListItem
                  button
                  onClick={() => handleOption(option.action)}
                  sx={{ px: 0, py: 0.5, '&:hover': { bgcolor: 'transparent', '& .MuiSvgIcon-root': { color: 'primary.main' } } }}
                >
                  <ListItemText
                    primary={option.label}
                    primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: '#484848' }}
                  />
                  <ListItemIcon sx={{ minWidth: 'auto' }}>
                    <ArrowForward sx={{ fontSize: 18, color: '#5c67f2' }} />
                  </ListItemIcon>
                </ListItem>
                {index !== options.length - 1 && <Divider component="li" />}
              </Fragment>
            ))}
          </List>
        </Box>
      </Stack>

    </Dialog >
  </>
}